import { motion } from "framer-motion";
import { PHOTOS } from "./assets";

export default function Coach() {
  const scrollTo = () =>
    document.querySelector("#assessment")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="coach"
      data-testid="coach-section"
      className="py-24 md:py-36 bg-[#0a0a0a] border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5 relative overflow-hidden border border-white/10"
          >
            <img
              src={PHOTOS.coach}
              alt="Coach JJ leading a training session"
              loading="lazy"
              className="w-full h-[440px] md:h-[560px] object-cover object-[center_15%] grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7"
          >
            <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
              About The Coach
            </p>
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl mb-8">
              Meet Coach Johnson
            </h2>
            <div className="space-y-5 text-white/65 text-base md:text-lg leading-relaxed max-w-2xl">
              <p>
                I'm a former Collegiate Head Cross Country & Track & Field Coach, an{" "}
                <span className="text-white font-medium">NCAA Division III Indoor National Champion (200m)</span>,
                and a <span className="text-white font-medium">6× NCAA All-American</span>.
              </p>
              <p>
                My journey as both an athlete and a coach taught me that success is
                built through consistency, discipline, perseverance, and trusting
                the process. I wouldn't be where I am today without the coaches,
                mentors, teammates, and people who invested their time and knowledge
                into helping me grow.
              </p>
              <p>
                Because of those experiences, I feel a responsibility to give that
                same knowledge, mentorship, and encouragement back to today's
                athletes. JJ Speed Factory exists to help athletes become not only
                faster and more explosive, but also more confident, disciplined,
                resilient, and prepared for success both in sports and in life.
              </p>
              <p>
                I want every athlete who trains with me to leave with more than
                improved speed — I want them to build habits, confidence, and
                character that benefit them long after their athletic careers are
                over.
              </p>
              <p className="text-white font-display uppercase tracking-tight text-xl md:text-2xl leading-tight pt-3 border-l-2 border-white/30 pl-5">
                My mission is simple: to help every athlete unlock their full
                potential through intentional coaching, proven training methods, and
                genuine mentorship — passing forward the same opportunities,
                knowledge, and guidance that helped shape my own journey.
              </p>
            </div>
            <button
              data-testid="coach-cta-btn"
              onClick={scrollTo}
              className="mt-10 border border-white/30 text-white uppercase tracking-[0.2em] font-bold text-sm px-10 py-5 hover:bg-white hover:text-black transition-colors duration-300"
            >
              Train With Coach Johnson
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
